/* jshint esnext: true */
var fooo = new Vue({
  el: '#totalCoordinate',
  template: '#totalCoordinate-template',

  data: {
    settings: {
      jsonPath: './data/total-coordinate.json',
      urlPrefixesPath: './data/total-coordinate-prefixes.json'
    },
    raw: []
  },

  created: function () {
    let _this = this;
    $.ajax({
      url: this.settings.jsonPath,
      dataType: 'json'
    })
    .done(data => _this.raw = data)
    .done(() => {
      _this.raw = shuffleArray(_this.raw);
      _this.raw = _this.raw.slice(0, 1);

      setPrefix();
    });

    function shuffleArray(array) {
      var n = array.length, t, i;

      while (n) {
        i = Math.floor(Math.random() * n--);
        t = array[n];
        array[n] = array[i];
        array[i] = t;
      }

      return array;
    }

    function setPrefix() {
      $.ajax({
        url: _this.settings.urlPrefixesPath,
        dataType: 'json'
      }).done(data => {
        let currentHost = window.location.host;
        let urlPrefixes = data[currentHost];

        return $.map(_this.raw, el => {
          el.mainLink = urlPrefixes.number_before + el.mainLink + urlPrefixes.number_after;
          el.sub1Link = urlPrefixes.number_before + el.sub1Link + urlPrefixes.number_after;
          el.sub2Link = urlPrefixes.number_before + el.sub2Link + urlPrefixes.number_after;

          return el;
        });
      });
    }
  }
});

Vue.nextTick(() => {
  $('#totalCoordinateCarousel').slick({
    mobileFirst: true,
    slidesToShow: 1,
    dots: true,
    fade: true,
    autoplay: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          fade: false,
          arrows: true
        }
      }
    ]
  });
});
